module.exports = __webpack_public_path__ + "img/header-ads.7949f2d1.png";